<template>
	<doughnut 
	:height="height"
	:chart-data="data" 
	:chart-options="options" />
</template>

<script> 

	import { Doughnut } from 'vue-chartjs/legacy'

	import { 
		Chart as ChartJS, 
		Title, 
		ArcElement,
		Tooltip, 
		Legend, 
		BarElement, 
		CategoryScale, 
		LinearScale 
	} from 'chart.js'

	ChartJS.register(Title, Tooltip, Legend, ArcElement, BarElement, CategoryScale, LinearScale)

	export default { 

		props: {

			height: {
				type: Number,
				default: 250
			},

			chartData: {
				type: Object,
				default: () => {}
			}, 

			options: {
				type: Object,
				default: () => {}
			}

		},

		data() {
			return {
				data: {}
			}
		},

		components: {
			Doughnut,
		},

		mounted() {
		if(this.chartData) {
			this.data = this.chartData
		}

		window.livewire.on("pieChartUpdated", data => {
			this.data = data
		})
	}

	}

</script> 